import "./scripts/upstairs";
import "./scripts/case_study";

import "./styles/portfolio.scss";
import "./styles/projects.scss";
import "./styles/service.scss";
import "./styles/upstairs.scss";
import "./styles/case_study.scss";
